import type { StarsWebExtraWallet } from '../types';

import { getIsWalletBonusCash, getIsWalletFreeBet } from './getIsWallet';

export const getDisplayableWallets = (
  wallets: StarsWebExtraWallet[],
  isBonusCashEnabled: boolean,
  isFreeBetsEnabled: boolean
): StarsWebExtraWallet[] =>
  wallets.filter(
    (wallet) =>
      (isBonusCashEnabled && getIsWalletBonusCash(wallet)) ||
      (isFreeBetsEnabled && getIsWalletFreeBet(wallet))
  );
